import { getNoContentApiClient } from 'adapter/out/client/apiClient';
import DeactivateAutomationCriteria from 'use-case/automation/deactivate/deactivateAutomationCriteria';

export default getNoContentApiClient(
    (criteria: DeactivateAutomationCriteria) => `dashboards/automations/${criteria.id}/deactivate`,
    () => ({
        method: 'POST'
    })
);
